const CircleWithInfoIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} {...props}>
    <g data-name="Certificate loschen" transform="translate(-6013 -6700)">
      <circle
        cx={50}
        cy={50}
        r={50}
        fill="#e8fcff"
        data-name="Ellipse 106"
        transform="translate(6013 6700)"
      />
      <path
        fill="#00c4de"
        d="M6061.1 6759.5h3.8v-11.4h-3.8Zm1.9-28.5a19 19 0 1 0 19 19 19.007 19.007 0 0 0-19-19Zm0 34.2a15.2 15.2 0 1 1 15.2-15.2 15.22 15.22 0 0 1-15.2 15.2Zm-1.9-20.9h3.8v-3.8h-3.8Z"
        data-name="Icon material-info-outline"
      />
    </g>
  </svg>
);

export default CircleWithInfoIcon;
